var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import _ from 'lodash';
import { VariableSizeGrid } from 'react-window';
import useTheme from '../../../../themes/hooks/UseTheme';
import StackLayout from '../../stackLayout/StackLayoutComponent';
import useActiveThemeVariation from '../../../../themes/hooks/UseActiveThemeVariation';
import { invokeEventHandler } from '../../../../../helpers/ReactShortcuts';
import useResponsiveValue from '../../../../themes/hooks/memoThemeAccessors/UseResponsiveValue';
import ScrollView from '../../scrollView/ScrollViewComponent';
import { Grid } from 'semantic-ui-react';
import CellRenderer from './cellRenderer/CellRenderer';
var GridImplementation = function (props) {
    var rowCount = props.rowCount, singleColumnRowIndices = props.singleColumnRowIndices, itemRenderer = props.itemRenderer, queryView = props.queryView, virtualized = props.virtualized, emptyRenderer = props.emptyRenderer, onLoadMore = props.onLoadMore, onItemsRendered = props.onItemsRendered;
    var theme = useTheme();
    var activeThemeVariation = useActiveThemeVariation(props, function (x) { return x.layoutThemes.grid; });
    var rowHeight = activeThemeVariation.rowHeight, columnCount = activeThemeVariation.columnCount;
    var overscanRowCount = useResponsiveValue(theme, activeThemeVariation.overscanRowCount);
    var loadMoreOffset = useResponsiveValue(theme, activeThemeVariation.loadMoreOffset);
    var _a = __read(useState(undefined), 2), boxWidth = _a[0], setBoxWidth = _a[1];
    var _b = __read(useState(undefined), 2), boxHeight = _b[0], setBoxHeight = _b[1];
    var variableSizeGridRef = useRef(null);
    useEffect(function () {
        if (!virtualized) {
            invokeEventHandler(onItemsRendered, ({ visibleRowStartIndex: 0, visibleRowStopIndex: rowCount }));
        }
    }, []);
    var ItemRendererComponent = useMemo(function () { return itemRenderer; }, [itemRenderer]);
    var actualColumnCount = useMemo(function () { return columnCount === undefined ? 0 : theme.resolveResponsiveValue(columnCount); }, [columnCount, boxWidth]);
    useEffect(_.debounce(function () {
        var _a;
        (_a = variableSizeGridRef.current) === null || _a === void 0 ? void 0 : _a.resetAfterIndices({
            rowIndex: 0,
            columnIndex: 0
        });
    }, 300, { leading: true }), [boxWidth, boxHeight, actualColumnCount]);
    var columnWidthResolver = useCallback(function () {
        return (boxWidth || 1) / actualColumnCount;
    }, [actualColumnCount, boxWidth]);
    var rowHeightResolver = useCallback(function (rowIndex) {
        if (!rowHeight) {
            return 0;
        }
        if (typeof rowHeight === 'function') {
            return rowHeight(rowIndex, columnWidthResolver());
        }
        return theme.resolveNumericFactor(rowHeight) || 0;
    }, [rowHeight, columnWidthResolver]);
    var itemsRenderedHandler = useCallback(function (params) {
        var remainingRows = rowCount - params.visibleRowStopIndex;
        if (loadMoreOffset !== undefined && remainingRows <= loadMoreOffset) {
            invokeEventHandler(onLoadMore);
        }
        invokeEventHandler(queryView === null || queryView === void 0 ? void 0 : queryView.loadMore);
        invokeEventHandler(onItemsRendered, params);
    }, [loadMoreOffset, rowCount, queryView, onItemsRendered, onLoadMore]);
    if (rowCount === 0) {
        return (React.createElement(StackLayout, { stretch: true }, emptyRenderer()));
    }
    if (!virtualized) {
        return (React.createElement(Grid, { style: { margin: 0 }, columns: actualColumnCount }, _.range(rowCount).map(function (rowIndex) { return (React.createElement(Grid.Row, { key: "row_" + rowIndex, style: { padding: 0 } }, _.range(actualColumnCount).map(function (columnIndex) { return (React.createElement(Grid.Column, { key: "row_" + rowIndex + "_column_" + columnIndex, style: { padding: 0 } },
            React.createElement(CellRenderer, { columnCount: actualColumnCount, ItemRendererComponent: ItemRendererComponent, rowIndex: rowIndex, columnIndex: columnIndex, singleColumnRowIndices: singleColumnRowIndices }))); }))); })));
    }
    return (React.createElement(ScrollView, { variationKey: activeThemeVariation.scrollViewVariation }, function (parameters) {
        var width = parameters.width, height = parameters.height;
        console.log('parameters', parameters);
        if (boxWidth !== width) {
            setBoxWidth(width);
        }
        if (boxHeight !== boxHeight) {
            setBoxHeight(height);
        }
        var simpleBarParameters = parameters;
        return (React.createElement(VariableSizeGrid, { ref: variableSizeGridRef, columnCount: actualColumnCount, rowCount: rowCount, rowHeight: rowHeightResolver, width: width, columnWidth: columnWidthResolver, height: height, innerRef: simpleBarParameters.contentNodeRef, outerRef: simpleBarParameters.scrollableNodeRef, onItemsRendered: itemsRenderedHandler, overscanRowCount: overscanRowCount }, function (_a) {
            var columnIndex = _a.columnIndex, rowIndex = _a.rowIndex, style = _a.style;
            return (React.createElement(CellRenderer, { columnCount: actualColumnCount, ItemRendererComponent: ItemRendererComponent, rowIndex: rowIndex, columnIndex: columnIndex, singleColumnRowIndices: singleColumnRowIndices, style: style }));
        }));
    }));
};
export default GridImplementation;
//# sourceMappingURL=GridImplementation.js.map